import * as tslib_1 from "tslib";
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { startOfYear, sub } from 'date-fns';
import { sentry } from 'sentry';
import { environment } from '../../../../environments/environment';
import { ExportDialogTypeEnum } from '../export-dialog/export-dialog.types';
import { ExportDialogService } from '../export-dialog/services/export-dialog.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var ExportDialogImrComponent = /** @class */ (function () {
    function ExportDialogImrComponent(matDialogRef, authenticationService, customMessageService, exportDialogService, fuseProgressBarService, fuseTranslationLoaderService) {
        this.matDialogRef = matDialogRef;
        this.authenticationService = authenticationService;
        this.customMessageService = customMessageService;
        this.exportDialogService = exportDialogService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.control = new FormControl(null, {
            validators: [Validators.required]
        });
        this.isExporting = false;
        this.email = this.authenticationService.user && this.authenticationService.user.email;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.maxDate = new Date();
        this.minDate = startOfYear(sub(new Date(), { years: 2 }));
    }
    ExportDialogImrComponent.prototype.export = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isExporting = true;
                        this.fuseProgressBarService.show();
                        input = this.exportDialogService.toCreateExportParams({
                            type: ExportDialogTypeEnum.maintenancesImr,
                            where: {
                                yearAndMonth: this.control.value.value,
                            },
                        });
                        return [4 /*yield*/, this.exportDialogService.createExport(input)];
                    case 1:
                        _a.sent();
                        this.customMessageService.success('EXPORT_DIALOG_IMR.MESSAGES.EXPORT_SUCCESS', {}, {
                            text: 'Ver exportações',
                            callback: function () {
                                location.href = environment.MOUNTDOOM_2_URL + '/#/exportacoes';
                            }
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        console.error('Error exporting IMR', err_1);
                        sentry.captureException(err_1);
                        this.customMessageService.error('EXPORT_DIALOG_IMR.MESSAGES.EXPORT_ERROR');
                        return [3 /*break*/, 4];
                    case 3:
                        this.isExporting = false;
                        this.matDialogRef.close();
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ExportDialogImrComponent;
}());
export { ExportDialogImrComponent };
